import sysConf from 'config';
import { getAwsAuthToken } from 'utils/lib/authHelper';
export async function handleStreamResponseForCognates({
  path='ai/generate-cognates-stream',
  body,
  onCognate,
  onDuplicate,
  onError,
  onDone,
  onFirstResponse
}) {
  try {
    const token = await getAwsAuthToken();
    const prodUrl = `${sysConf.apiGateway.AI_BASE_NODE_URL}/${path}`;
    const localUrl = `http://localhost:4000/${path}`;
    const url = sysConf.is_local ? localUrl : prodUrl;
    let firstResponseSent = false;
    const response = await fetch(prodUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-auth-source': sysConf.isDev ? 'test' : 'prod',
      },
      body: JSON.stringify(body),
    });

    if (!response.ok || !response.body) {
      throw new Error('Stream failed to start');
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder('utf-8');
    let partial = '';
    let currentEvent = '';

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
        if (!firstResponseSent) {
            onFirstResponse?.(); // ✅ Trigger once
            firstResponseSent = true;
        }

      partial += decoder.decode(value, { stream: true });
      const lines = partial.split(/\r?\n/);

      for (let i = 0; i < lines.length; i++) {
        const line = lines[i].trim();
        if (!line) continue;

        if (line.startsWith('event:')) {
          currentEvent = line.slice(6).trim();
        } else if (line.startsWith('data:')) {
          const payload = line.slice(5).trim();
          if (payload === '[DONE]') {
            onDone?.();
            return;
          }

          try {
            const parsed = JSON.parse(payload);

            switch (currentEvent) {
              case 'cognate':
                onCognate?.(parsed);
                break;
              case 'duplicate':
                onDuplicate?.(parsed);
                break;
              case 'error':
                onError?.(parsed);
                break;
              default:
                console.warn('Unhandled stream event:', currentEvent, parsed);
            }
          } catch (err) {
            console.error('Failed to parse stream JSON:', payload, err);
          }
        }
      }

      partial = lines[lines.length - 1].endsWith('\n') ? '' : lines[lines.length - 1];
    }
  } catch (err) {
    console.error('Stream error:', err);
    onError?.(err);
  }
}